import css from 'styled-jsx/css';
import { fontSizes, colors } from '../../../../themes/index';

export default css`
  .sources-wrapper {
    background: #f5f5f5;
    padding: 20px 15px;
    width: 100%;
  }

  .sources-wrapper p {
    color: ${colors.grayDark};
    font-size: ${fontSizes.small};
    text-align: center;
    margin: 0 0 15px;
  }

  .sources-wrapper .images-wrapper {
    align-items: center;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
  }

  .sources-wrapper .images-wrapper img {
    height: 38px;
    margin: 5px 10px;
    width: auto;
  }
`;



// WEBPACK FOOTER //
// ./app/Sources/list/components/SourcesList/styles.js